import { render, staticRenderFns } from "./Tipo_Niveles_cargo.vue?vue&type=template&id=b1ce8102&scoped=true"
import script from "./Tipo_Niveles_cargo.vue?vue&type=script&lang=js"
export * from "./Tipo_Niveles_cargo.vue?vue&type=script&lang=js"
import style0 from "./Tipo_Niveles_cargo.vue?vue&type=style&index=0&id=b1ce8102&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b1ce8102",
  null
  
)

export default component.exports